export interface ProblemDetails {
  type?: string;
  title?: string;
  status?: number;
  detail?: string;
  instance?: string;
  errors?: Record<string, string[]>;
  traceId?: string;
}

/**
 * Transport and API failures. `status === null` means the request never got a
 * response (offline, DNS, timeout) - the retry policy treats that as retryable.
 */
export class ApiError extends Error {
  readonly status: number | null;
  readonly problem: ProblemDetails | null;
  readonly traceId: string | null;

  constructor(message: string, status: number | null, problem: ProblemDetails | null = null) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.problem = problem;
    this.traceId = problem?.traceId ?? null;
  }

  get fieldErrors(): Record<string, string[]> {
    return this.problem?.errors ?? {};
  }

  static network(cause: unknown): ApiError {
    const error = new ApiError('Network request failed', null);
    error.cause = cause;
    return error;
  }
}
